<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb -->
    <div class="mb-3 row">
      <div class="col-11">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/tramite">Trámites</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm', params: { idTramite } }">
                Trámite N.° {{ idTramite }}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm',
                                  params: { p_idtramite },
                                  query: { tab: 'reportes' } }">
                Reportes
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Fechas fuera de Periodo
            </li>
          </ol>
        </nav>
      </div>
      <div class="col-1 text-end">
        <span
          class="material-symbols-outlined text-primary"
          style="font-size:32px; cursor:pointer"
          @click="showModalHelp = true"
        >help</span>
      </div>
    </div>

    <!-- Info trámite -->
    <div class="card border-0 mb-3" style="background-color:#e8f4fd;">
      <div class="card-body py-2 px-3">
        <span class="text-dark fw-bold">{{ datosTramite }}</span>
      </div>
    </div>

    <!-- Toolbar global -->
    <div class="card border-0 shadow-sm mb-3">
      <div class="card-body">
        <div class="row align-items-end g-3">
          <!-- Fecha global -->
          <div class="col-auto">
            <label class="form-label fw-bold">
              <span class="material-symbols-outlined align-middle" style="font-size:1rem;">calendar_today</span>
              Fecha de corrección (global)
            </label>
            <input
              type="date"
              class="form-control"
              v-model="fechaNueva"
              :min="fechaMin"
              :max="fechaMax"
            />
            <small class="text-muted" v-if="fechaMin && fechaMax">
              Periodo: {{ formatFecha(fechaMin) }} — {{ formatFecha(fechaMax) }}
            </small>
          </div>

          <!-- Filtro planilla -->
          <div class="col-auto" v-if="hayDatos">
            <label class="form-label fw-bold">
              <span class="material-symbols-outlined align-middle" style="font-size:1rem;">filter_list</span>
              Filtrar planilla
            </label>
            <select class="form-select" v-model="filtroPlanilla">
              <option value="">Todas ({{ datos.length }})</option>
              <option
                v-for="p in planillasLista"
                :key="p.numero"
                :value="p.numero"
              >
                {{ p.numero }} — {{ p.nombre }} ({{ p.count }})
              </option>
            </select>
          </div>

          <!-- Botones -->
          <div class="col-auto d-flex gap-2 flex-wrap">
            <button
              class="btn btn-outline-primary"
              @click="cargar"
              :disabled="cargando || ejecutando"
            >
              <span class="material-symbols-outlined align-middle">preview</span>
              {{ cargando ? 'Cargando...' : 'Ver Preview' }}
            </button>
            <button
              class="btn btn-outline-secondary"
              @click="dryRunSeleccionados"
              :disabled="!haySeleccionados || !fechaNueva"
            >
              Simular seleccionados
            </button>
            <button
              class="btn btn-outline-secondary"
              @click="dryRun"
              :disabled="!fechaNueva || cargando || ejecutando"
            >
              <span class="material-symbols-outlined align-middle">play_circle</span>
              {{ ejecutando ? 'Simulando...' : 'Simular' }}
            </button>
            <button
              class="btn btn-warning"
              @click="ejecutarSeleccionados"
              :disabled="!haySeleccionados || !fechaNueva || ejecutando || cargando"
              :title="!haySeleccionados ? 'Selecciona al menos un registro' : ''"
            >
              <span class="material-symbols-outlined align-middle">edit_calendar</span>
              {{ ejecutando ? 'Corrigiendo...' : `Corregir ${haySeleccionados ? seleccionados.size : ''} seleccionados` }}
            </button>
            <button
              class="btn btn-danger"
              @click="ejecutarTodos"
              :disabled="!hayDatos || !fechaNueva || ejecutando || cargando"
            >
              <span class="material-symbols-outlined align-middle">warning</span>
              Corregir todos ({{ datos.length }})
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Consola -->
    <div v-if="mensajes.length > 0" class="mb-3">
      <div class="d-flex align-items-center justify-content-between mb-1">
        <span class="fw-bold text-secondary">
          <span class="material-symbols-outlined align-middle">terminal</span>
          Log del proceso
        </span>
        <button class="btn btn-sm btn-outline-secondary" @click="mensajes = []">
          <span class="material-symbols-outlined align-middle" style="font-size:1rem;">delete</span>
          Limpiar
        </button>
      </div>
      <div class="consola p-3 rounded">
        <div
          v-for="(m, i) in mensajes"
          :key="i"
          class="consola-linea"
          :class="'nivel-' + m.nivel.toLowerCase()"
        >
          <span class="consola-nivel">{{ m.nivel }}</span>
          <span class="consola-mensaje">{{ m.mensaje }}</span>
        </div>
      </div>
    </div>

    <!-- Error -->
    <div v-if="error" class="alert alert-danger">
      <span class="material-symbols-outlined align-middle">error</span>
      {{ error }}
    </div>

    <!-- Sin datos -->
    <div v-if="!hayDatos && !cargando && consultado" class="alert alert-success">
      <span class="material-symbols-outlined align-middle">check_circle</span>
      No hay registros fuera de periodo para este trámite.
    </div>

    <!-- Spinner -->
    <div v-if="cargando" class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
    </div>

    <!-- Resumen + Tabla -->
    <template v-if="hayDatos">

      <!-- Tarjetas resumen -->
      <div class="d-flex align-items-center gap-3 mb-3 flex-wrap">
        <div class="card border-0 px-3 py-2" style="background-color:#fef2f2;">
          <small class="text-muted">Total fuera de periodo</small>
          <span class="fw-bold text-danger fs-5">{{ datos.length }}</span>
        </div>
        <div class="card border-0 px-3 py-2" style="background-color:#fff7ed;">
          <small class="text-muted">Planillas afectadas</small>
          <span class="fw-bold text-warning fs-5">{{ planillasUnicas }}</span>
        </div>
        <div class="card border-0 px-3 py-2" style="background-color:#f0fdf4;" v-if="haySeleccionados">
          <small class="text-muted">Seleccionados</small>
          <span class="fw-bold text-success fs-5">{{ seleccionados.size }}</span>
        </div>
        <div class="card border-0 px-3 py-2" style="background-color:#fef9c3;">
          <small class="text-muted">Mostrando (filtro)</small>
          <span class="fw-bold text-warning fs-5">{{ datosFiltrados.length }}</span>
        </div>
      </div>

      <!-- Acciones selección rápida -->
      <div class="d-flex gap-2 mb-2 align-items-center">
        <button class="btn btn-sm btn-outline-secondary" @click="seleccionarTodos">
          <span class="material-symbols-outlined align-middle" style="font-size:1rem;">select_all</span>
          Seleccionar todos visibles
        </button>
        <button class="btn btn-sm btn-outline-secondary" @click="deseleccionarTodos" v-if="haySeleccionados">
          <span class="material-symbols-outlined align-middle" style="font-size:1rem;">deselect</span>
          Limpiar selección
        </button>
        <span class="text-muted ms-2" v-if="haySeleccionados">
          {{ seleccionados.size }} registro(s) seleccionado(s)
        </span>
      </div>

      <!-- Tabla -->
      <div class="card border-0 shadow">
        <div class="card-header d-flex align-items-center gap-2" style="background-color:#fef9c3;">
          <span class="material-symbols-outlined text-warning">schedule</span>
          <span class="fw-bold text-warning">
            Registros con fecha de atención fuera del periodo
          </span>
        </div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table>
              <thead>
                <tr>
                  <th class="text-center" style="width:40px;">
                    <input
                      type="checkbox"
                      :checked="todosVisiblesSeleccionados"
                      :indeterminate.prop="algunosSeleccionados"
                      @change="toggleTodosVisibles"
                      title="Seleccionar/deseleccionar todos visibles"
                    />
                  </th>
                  <th>Planilla</th>
                  <th>Paciente</th>
                  <th class="text-center">Periodo</th>
                  <th class="text-center">Fecha Atención</th>
                  <th class="text-center">Días fuera</th>
                  <th>Código</th>
                  <th>Descripción</th>
                  <th class="text-center">Cantidad</th>
                  <th class="text-end">Valor Unit.</th>
                  <th class="text-center">Acción individual</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="f in datosFiltrados"
                  :key="f.idPlanillaDet"
                  :class="{ 'fila-seleccionada': seleccionados.has(f.idPlanillaDet), 'fila-editando': editando[f.idPlanillaDet] }"
                  @dblclick="abrirPlanillaPopup(f.idPlanilla)"
                >
                  <!-- Checkbox -->
                  <td class="text-center">
                    <input
                      type="checkbox"
                      :checked="seleccionados.has(f.idPlanillaDet)"
                      @change="toggleSeleccion(f.idPlanillaDet)"
                    />
                  </td>

                  <td class="fw-bold">{{ f.planillaNumero }}</td>
                  <td>{{ f.planillaNombre }}</td>

                  <!-- Periodo -->
                  <td class="text-center" style="font-size:0.82rem; white-space:nowrap;">
                    <span class="text-success">{{ formatFecha(f.fechaDesde) }}</span>
                    <span class="text-muted mx-1">→</span>
                    <span class="text-success">{{ formatFecha(f.fechaHasta) }}</span>
                  </td>

                  <!-- Fecha atención -->
                  <td class="text-center">
                    <span class="badge bg-danger">
                      {{ formatFecha(f.fechaAtencion) }}
                    </span>
                  </td>

                  <!-- Días fuera -->
                  <td class="text-center">
                    <span
                      class="badge"
                      :class="diasFueraBadgeClass(f)"
                      :title="diasFueraTooltip(f)"
                    >
                      {{ diasFuera(f) }}d
                    </span>
                  </td>

                  <td>
                    <span class="badge bg-secondary">{{ f.codigo }}</span>
                  </td>
                  <td>{{ f.descripcion }}</td>
                  <td class="text-center">{{ f.cantidad }}</td>
                  <td class="text-end">{{ formatMoneda(f.valorUni) }}</td>

                  <!-- Acción individual -->
                  <td class="text-center" style="min-width: 220px;">
                    <div v-if="!editando[f.idPlanillaDet]" class="d-flex justify-content-center gap-1">
                      <button
                        class="btn btn-sm btn-outline-primary"
                        @click="iniciarEdicion(f)"
                        title="Editar fecha de este registro"
                      >
                        <span class="material-symbols-outlined" style="font-size:1rem;">edit_calendar</span>
                        Editar
                      </button>
                    </div>
                    <div v-else class="d-flex align-items-center gap-1 justify-content-center">
                      <input
                        type="date"
                        class="form-control form-control-sm"
                        style="width:140px;"
                        v-model="fechasEdicion[f.idPlanillaDet]"
                        :min="toISODate(f.fechaDesde)"
                        :max="toISODate(f.fechaHasta)"
                      />
                      <button
                        class="btn btn-sm btn-success"
                        @click="guardarIndividual(f)"
                        :disabled="!fechasEdicion[f.idPlanillaDet] || guardandoId === f.idPlanillaDet"
                        title="Guardar"
                      >
                        <span class="material-symbols-outlined" style="font-size:1rem;">
                          {{ guardandoId === f.idPlanillaDet ? 'hourglass_empty' : 'check' }}
                        </span>
                      </button>
                      <button
                        class="btn btn-sm btn-outline-secondary"
                        @click="cancelarEdicion(f.idPlanillaDet)"
                        title="Cancelar"
                      >
                        <span class="material-symbols-outlined" style="font-size:1rem;">close</span>
                      </button>
                    </div>
                    <!-- Mini feedback inline -->
                    <div v-if="feedbackIndividual[f.idPlanillaDet]" class="mt-1">
                      <span
                        class="badge"
                        :class="feedbackIndividual[f.idPlanillaDet].ok ? 'bg-success' : 'bg-danger'"
                        style="font-size:0.75rem;"
                      >
                        {{ feedbackIndividual[f.idPlanillaDet].msg }}
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>

    <!-- Modal Ayuda -->
    <div v-if="showModalHelp" class="modal fade show d-block" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <span class="material-symbols-outlined align-middle">help</span>
              Ayuda — Fechas fuera de Periodo
            </h5>
            <button type="button" class="btn-close" @click="showModalHelp = false" />
          </div>
          <div class="modal-body">
            <p>
              Muestra los registros de detalle cuya fecha de atención no corresponde
              al periodo de la planilla a la que pertenecen.
            </p>
            <ol>
              <li><strong>Ver Preview</strong>: lista los registros afectados.</li>
              <li><strong>Filtrar planilla</strong>: enfócate en una planilla específica.</li>
              <li><strong>Selección</strong>: usa los checkboxes para elegir registros a corregir.</li>
              <li><strong>Editar</strong>: botón individual por fila para cambiar solo esa fecha.</li>
              <li><strong>Simular</strong>: muestra el log sin modificar datos.</li>
              <li><strong>Corregir seleccionados</strong>: aplica la fecha global a los marcados.</li>
              <li><strong>Corregir todos</strong>: aplica la fecha global a todos los registros.</li>
            </ol>
            <p class="text-muted">
              La columna <strong>Días fuera</strong> indica cuántos días está la fecha de atención
              fuera del periodo válido. Rojo intenso = más grave.
            </p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="showModalHelp = false">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showModalHelp" class="modal-backdrop fade show" @click="showModalHelp = false" />

    <!-- Modal confirmación corregir seleccionados -->
    <div v-if="showModalConfirm" class="modal fade show d-block" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header bg-warning">
            <h5 class="modal-title">
              <span class="material-symbols-outlined align-middle">warning</span>
              Confirmar corrección
            </h5>
            <button type="button" class="btn-close" @click="showModalConfirm = false" />
          </div>
          <div class="modal-body">
            <p>Se actualizará la fecha de atención a <strong>{{ formatFecha(fechaNueva) }}</strong> en:</p>
            <ul>
              <li v-if="confirmMode === 'seleccionados'">
                <strong>{{ seleccionados.size }}</strong> registro(s) seleccionado(s)
              </li>
              <li v-else>
                <strong>{{ datos.length }}</strong> registro(s) — TODOS
              </li>
            </ul>
            <p class="text-danger fw-bold">Esta acción no se puede deshacer.</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="showModalConfirm = false">Cancelar</button>
            <button class="btn btn-warning" @click="confirmarEjecucion" :disabled="ejecutando">
              <span class="material-symbols-outlined align-middle">edit_calendar</span>
              {{ ejecutando ? 'Corrigiendo...' : 'Confirmar' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showModalConfirm" class="modal-backdrop fade show" @click="showModalConfirm = false" />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import api from "@/services/api";
import { abrirPlanillaPopup } from "@/assets/js/popup.js";

export default {
  name: "FueraPeriodo",
  components: { Layout },
  props: {
    p_idtramite: { type: String, required: true }
  },
  data() {
    return {
      idTramite:          Number(this.p_idtramite),
      datos:              [],
      fechaNueva:         "",
      fechaMin:           "",
      fechaMax:           "",
      cargando:           false,
      ejecutando:         false,
      consultado:         false,
      error:              null,
      showModalHelp:      false,
      showModalConfirm:   false,
      confirmMode:        "seleccionados", // 'seleccionados' | 'todos'
      datosTramite:       "",
      mensajes:           [],
      filtroPlanilla:     "",
      // Selección múltiple
      seleccionados:      new Set(),
      // Edición inline individual
      editando:           {},   // { idPlanillaDet: true/false }
      fechasEdicion:      {},   // { idPlanillaDet: "yyyy-mm-dd" }
      guardandoId:        null,
      feedbackIndividual: {},   // { idPlanillaDet: { ok, msg } }
    };
  },
  computed: {
    hayDatos() {
      return this.datos.length > 0;
    },
    planillasUnicas() {
      return new Set(this.datos.map(f => f.planillaNumero)).size;
    },
    planillasLista() {
      const map = {};
      this.datos.forEach(f => {
        if (!map[f.planillaNumero]) {
          map[f.planillaNumero] = { numero: f.planillaNumero, nombre: f.planillaNombre, count: 0 };
        }
        map[f.planillaNumero].count++;
      });
      return Object.values(map).sort((a, b) => String(a.numero).localeCompare(String(b.numero)));
    },
    datosFiltrados() {
      if (!this.filtroPlanilla) return this.datos;
      return this.datos.filter(f => String(f.planillaNumero) === String(this.filtroPlanilla));
    },
    haySeleccionados() {
      return this.seleccionados.size > 0;
    },
    todosVisiblesSeleccionados() {
      return this.datosFiltrados.length > 0 &&
        this.datosFiltrados.every(f => this.seleccionados.has(f.idPlanillaDet));
    },
    algunosSeleccionados() {
      return this.haySeleccionados && !this.todosVisiblesSeleccionados;
    },
  },
  async mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.datosTramite = sessionStorage.getItem("datosTramite");
  },
  methods: {
/*  
    formatFecha(fecha) {
      if (!fecha) return "-";
      return new Date(fecha).toLocaleDateString("es-EC");
    },
*/
formatFecha(fecha) {
  if (!fecha) return "-";
  // Tomar solo la parte de fecha "yyyy-mm-dd" y reformatear
  const partes = fecha.split("T")[0].split("-"); // ["2026","02","03"]
  return `${partes[2]}/${partes[1]}/${partes[0]}`; // "03/02/2026"
},
    formatMoneda(valor) {
      if (valor == null) return "-";
      return Number(valor).toLocaleString("es-EC", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    toISODate(fecha) {
      if (!fecha) return "";
      return new Date(fecha).toISOString().split("T")[0];
    },
    calcularRangoFechas() {
      if (!this.datos.length) return;
      const fechas = this.datos.flatMap(f => [new Date(f.fechaDesde), new Date(f.fechaHasta)]);
      const min = new Date(Math.min(...fechas));
      const max = new Date(Math.max(...fechas));
      this.fechaMin = min.toISOString().split("T")[0];
      this.fechaMax = max.toISOString().split("T")[0];
    },

    // --- Días fuera del periodo ---
    diasFuera(f) {
      const atencion = new Date(f.fechaAtencion);
      const desde    = new Date(f.fechaDesde);
      const hasta    = new Date(f.fechaHasta);
      if (atencion < desde) return Math.round((desde - atencion) / 86400000);
      if (atencion > hasta) return Math.round((atencion - hasta) / 86400000);
      return 0;
    },
    diasFueraBadgeClass(f) {
      const d = this.diasFuera(f);
      if (d <= 7)  return "bg-warning text-dark";
      if (d <= 30) return "badge-naranja";
      return "bg-danger";
    },
    diasFueraTooltip(f) {
      const atencion = new Date(f.fechaAtencion);
      const desde    = new Date(f.fechaDesde);
      const hasta    = new Date(f.fechaHasta);
      if (atencion < desde) return `Fecha anterior al inicio del periodo por ${this.diasFuera(f)} día(s)`;
      if (atencion > hasta) return `Fecha posterior al fin del periodo por ${this.diasFuera(f)} día(s)`;
      return "";
    },

    // --- Selección múltiple ---
    toggleSeleccion(id) {
      const s = new Set(this.seleccionados);
      if (s.has(id)) s.delete(id); else s.add(id);
      this.seleccionados = s;
    },
    seleccionarTodos() {
      const s = new Set(this.seleccionados);
      this.datosFiltrados.forEach(f => s.add(f.idPlanillaDet));
      this.seleccionados = s;
    },
    deseleccionarTodos() {
      this.seleccionados = new Set();
    },
    toggleTodosVisibles(e) {
      if (e.target.checked) this.seleccionarTodos();
      else {
        const s = new Set(this.seleccionados);
        this.datosFiltrados.forEach(f => s.delete(f.idPlanillaDet));
        this.seleccionados = s;
      }
    },

    // --- Edición inline individual ---
    iniciarEdicion(f) {
      this.editando = { ...this.editando, [f.idPlanillaDet]: true };
      this.fechasEdicion = {
        ...this.fechasEdicion,
        [f.idPlanillaDet]: this.toISODate(f.fechaAtencion)
      };
      // Limpiar feedback anterior
      const fb = { ...this.feedbackIndividual };
      delete fb[f.idPlanillaDet];
      this.feedbackIndividual = fb;
    },
    cancelarEdicion(id) {
      const e = { ...this.editando };
      delete e[id];
      this.editando = e;
    },
    async guardarIndividual(f) {
      const fechaNuevaInd = this.fechasEdicion[f.idPlanillaDet];
      if (!fechaNuevaInd) return;
      this.guardandoId = f.idPlanillaDet;
      try {
        await api.post("/fuera-periodo/ejecutar-individual", null, {
          params: {
            idPlanillaDet: f.idPlanillaDet,
            fechaNueva:    fechaNuevaInd
          }
        });
        // Feedback positivo
        this.feedbackIndividual = {
          ...this.feedbackIndividual,
          [f.idPlanillaDet]: { ok: true, msg: `✓ Actualizado a ${this.formatFecha(fechaNuevaInd)}` }
        };
        this.cancelarEdicion(f.idPlanillaDet);
        // Recargar después de un momento
			if (this._reloadTimer) clearTimeout(this._reloadTimer);
        this._reloadTimer = setTimeout(() => this.cargar(), 1200);
      } catch (e) {
        this.feedbackIndividual = {
          ...this.feedbackIndividual,
          [f.idPlanillaDet]: { ok: false, msg: "Error al guardar" }
        };
      } finally {
        this.guardandoId = null;
      }
    },

    // --- Acciones globales ---
    async cargar() {
      this.cargando    = true;
      this.error       = null;
      this.consultado  = false;
      this.seleccionados = new Set();
      this.editando    = {};
      this.feedbackIndividual = {};
      try {
        const { data } = await api.get("/fuera-periodo/preview", {
          params: { idTramite: this.idTramite }
        });
        this.datos = data;
        this.calcularRangoFechas();
      } catch (e) {
        this.error = "Error al cargar el preview: " + (e.response?.data?.error || e.message);
      } finally {
        this.cargando   = false;
        this.consultado = true;
      }
    },
    async dryRun() {
      this.ejecutando = true;
      this.mensajes   = [];
      this.error      = null;
      try {
        const { data } = await api.post("/fuera-periodo/dry-run", null, {
          params: { idTramite: this.idTramite, fechaNueva: this.fechaNueva }
        });
        this.mensajes = data;
      } catch (e) {
        this.error = "Error en simulación: " + (e.response?.data?.error || e.message);
      } finally {
        this.ejecutando = false;
      }
    },
    async dryRunSeleccionados() {
      this.ejecutando = true;
      this.mensajes = [];

      try {
        const { data } = await api.post(
          "/fuera-periodo/dry-run-sel",
          {
            ids: [...this.seleccionados],
            todos: false
          },
          {
            params: {
              idTramite: this.idTramite,
              fechaNueva: this.fechaNueva
            }
          }
        );

        this.mensajes = data;

      } catch (e) {
        this.error = "Error en simulación";
      } finally {
        this.ejecutando = false;
      }
    },
    ejecutarSeleccionados() {
      this.confirmMode      = "seleccionados";
      this.showModalConfirm = true;
    },
    ejecutarTodos() {
      this.confirmMode      = "todos";
      this.showModalConfirm = true;
    },
    async confirmarEjecucion() {
      this.ejecutando      = true;
      this.mensajes        = [];
      this.error           = null;
      this.showModalConfirm = false;
      try {
        const ids = this.confirmMode === "seleccionados"
          ? [...this.seleccionados]
          : null; // null = todos en el backend

        const { data } = await api.post("/fuera-periodo/ejecutar", {
          ids,
          todos: this.confirmMode === "todos"
        }, {
          params: { idTramite: this.idTramite, fechaNueva: this.fechaNueva }
        });
        this.mensajes = data;
        this.seleccionados = new Set();
        await this.cargar();
      } catch (e) {
        this.error = "Error al ejecutar: " + (e.response?.data?.error || e.message);
      } finally {
        this.ejecutando = false;
      }
    },
  abrirPlanillaPopup(idPlanilla) {
    abrirPlanillaPopup(idPlanilla);
  },

  }
};
</script>

<style scoped>
.modal-content { background-color: #f9fafb; }

table { width: 100%; border-collapse: collapse; }
th {
  background-color: #e0f2fe;
  color: #0369a1;
  font-weight: bold;
  padding: 0.5rem;
  border: 1px solid #bae6fd;
  white-space: nowrap;
}
td { padding: 0.5rem; border: 1px solid #e0f2fe; vertical-align: middle; }
tr:nth-child(even)   { background-color: #f0f9ff; }
tr:hover             { background-color: #dbeafe; }
tr.fila-seleccionada { background-color: #dcfce7 !important; }
tr.fila-editando     { background-color: #fefce8 !important; outline: 2px solid #fbbf24; }

.badge-naranja {
  background-color: #ea580c;
  color: #fff;
}

.consola {
  background-color: #1e1e2e;
  font-family: 'Courier New', monospace;
  font-size: 0.85rem;
  max-height: 300px;
  overflow-y: auto;
}
.consola-linea {
  display: flex;
  gap: 0.75rem;
  padding: 2px 0;
  border-bottom: 1px solid #2a2a3e;
}
.consola-nivel {
  min-width: 70px;
  font-weight: bold;
  text-align: center;
  border-radius: 3px;
  padding: 0 4px;
}
.consola-mensaje { color: #cdd6f4; }
.nivel-ok    .consola-nivel { background-color: #166534; color: #bbf7d0; }
.nivel-info  .consola-nivel { background-color: #1e3a5f; color: #bae6fd; }
.nivel-skip  .consola-nivel { background-color: #3f3f00; color: #fef08a; }
.nivel-error .consola-nivel { background-color: #7f1d1d; color: #fecaca; }
</style>